module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/Folder-error-84c1417983cd85f1d41bb82ddab87ff3.svg";